export default class utils {
  // Determines if the site is running within an iframe.
  static runningInIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  static formatDisplayText(text) {
    text = this.applyTextFormatting(text, "**", "**", "<strong>", "</strong>");
    text = this.applyTextFormatting(text, "~~", "~~", "<i>", "</i>");

    return text;
  }

  static applyTextFormatting(
    text,
    startIndicator,
    endIndicator,
    startReplacement,
    endReplacement
  ) {
    while (
      text.indexOf(startIndicator) !== -1 &&
      text.indexOf(
        endIndicator,
        text.indexOf(startIndicator) + startIndicator.length
      ) !== -1
    ) {
      text = text.replace(startIndicator, startReplacement);
      text = text.replace(endIndicator, endReplacement);
    }

    return text;
  }

  static getIncrementDisplay(index, incrementType) {
    const alphanumericVals = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let incrementDisplay = "";

    if (incrementType === "A") {
      if (index < alphanumericVals.length) {
        incrementDisplay = alphanumericVals.slice(index, index + 1);
      } else {
        // TODO: Calculate AA, AB, AC, etc..
        incrementDisplay = "??";
      }
    } else {
      incrementDisplay = index + 1;
    }

    return incrementDisplay + ".";
  }
}
